import React, { useState, useEffect } from 'react'
import { PaginationControl } from "react-bootstrap-pagination-control";
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import { Link } from 'react-router-dom'
import { Get, Delete } from '../../web_api/api'
import 'react-photo-view/dist/react-photo-view.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { FaImages } from "react-icons/fa";
import '../../branch/branch.css'

export default function PromoList() {

    const [dataCount, setDataCount] = useState("");
    const [page, setPage] = useState(1)
    const [blogList, setBlogList] = useState([])
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    //for pagination 
    const paginationItems = React.useMemo(() => {
        const start = (page - 1) * rowsPerPage;
        const end = start + rowsPerPage;
        return blogList.slice(start, end);
    }, [page, blogList]);

    // to delete list's item
    const handleDelete = async (event) => {
        await Delete('/promotion-page/', event)
        const result = blogList.filter(item => item._id !== event)
        setBlogList(result)
    }

    useEffect(() => {
        const getBlogs = async () => {
            const res = await Get('promotion-pages')
            console.log(res.data, 'blog')
            setBlogList(res.data)
            setDataCount(res.data.length)
        }
        getBlogs()
    }, [])

    return (
        <div className='branch-page'>
            <div className='branch-breadcrumb'>
                <span className='current'>Promotion List</span>
            </div>

            <div className='branch-card'>
                <div className='branch-card-header'>
                    <span />
                    <Link to='/promotion-create' className='branch-btn branch-btn-primary'>
                        + Add
                    </Link>
                </div>

                <div className='branch-card-body' style={{ padding: 0 }}>
                    <div className='branch-table-wrapper'>
                        <table className='branch-table'>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Promotion Title</th>
                                    <th>Sub Title</th>
                                    <th>Image</th>
                                    <th>Description</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginationItems.map((promo, i) => (
                                    <tr key={i}>
                                        <td>{++i}</td>
                                        <td>{promo.title}</td>
                                        <td>{promo.sub_title}</td>
                                        <td>
                                            {promo.image && (
                                                <img src={promo.image} alt='promo' style={{ width: '100px', height: '60px', objectFit: 'cover', borderRadius: '4px', border: '1px solid #ddd' }} />
                                            )}
                                        </td>
                                        <td>{promo.description.substring(0, 100)}</td>
                                        <td>
                                            <IconButton
                                                aria-label='delete'
                                                onClick={() => handleDelete(promo._id)}
                                            >
                                                <DeleteIcon className='text-danger' />
                                            </IconButton>
                                            <Link to={'/promotion-update/' + promo._id}>
                                                <IconButton aria-label='edit'>
                                                    <EditIcon className='text-warning' />
                                                </IconButton>
                                            </Link>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className='branch-pagination'>
                        <PaginationControl
                            page={page}
                            between={4}
                            total={dataCount}
                            limit={10}
                            changePage={(page) => {
                                setPage(page);
                            }}
                            ellipsis={1}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}





